module.exports = __webpack_public_path__ + "static/Main-Graphic@3x-fce377734e4c50ff3916e0f6a2dad35e.png";